module.exports = __webpack_public_path__ + "img/training_banner.003a40c5.jpg";